<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="mb-md">
          <div class="columns is-vcentered">
            <div class="column is-one-third">
              <breadcrumbs :history="breadcrumbs.history" :current="breadcrumbs.current"/>
            </div>
            <div class="column is-one-third">
              <h1 class="has-text-centered is-size-4">Returnly Settings</h1>
            </div>
          </div>
        </div>
        <!-- Pull RMAs (Retailers) -->
        <div v-if="!loading && account !== null && context.isMerchant()" class="border-b mb-xl pb-xl">
          <PullReturns :account="account" @update:account="load(true)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PullReturns from '../components/Returnly/PullReturns'
export default {
  components: {
    PullReturns
  },
  data () {
    return {
      loading: true,
      account: null
    }
  },
  computed: {
    ...mapGetters(['context']),
    breadcrumbs () {
      return {
        current: (this.loading) ? 'Loading...' : 'Returnly',
        history: [
          { label: 'Settings', name: 'settings' },
          { label: 'Integrations', name: 'settings.integrations' }
        ]
      }
    },
    endpoint () {
      return this.context.route + '/platform-accounts/' + this.$route.params.id + '/'
    }
  },
  methods: {
    load (refresh = false) {
      this.loading = (!refresh)
      this.$http.get(this.endpoint).then(response => {
        this.account = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.load()
  },
  props: []
}
</script>
